import { render, staticRenderFns } from "./ModalCadastroHorario.vue?vue&type=template&id=240bfdb6"
import script from "./ModalCadastroHorario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroHorario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports